export enum absenceTypes {
    LOADING = "LOADING",
    SELECTED_ABSENCE = "SELECTED_ABSENCE",
    GET_ABSENCE_LIST = "GET_ABSENCE_LIST",
}
  
export default absenceTypes;